import React, { FC } from "react";
import { IRoom, setClass } from "../../../../../utils";
import {
  Camera,
  Telephone,
  Display,
  Projector,
  TouchScreen,
} from "../../../../svgs";
import {
  getTypeOfCountingPlural,
  seatsPlural,
} from "../../../../../utils/constants/pluralForm";

interface RoomOptionProps {
  room: IRoom;
  isSelected: boolean;
}

export const RoomOption: FC<RoomOptionProps> = ({ room, isSelected }) => {
  const iconClassName = setClass("rooms-options", isSelected && "active");
  return (
    <div className="option-room">
      <p className={setClass("room-text-field", isSelected && "active")}>
        {`${room.cabinetNumber} ${room.conferenceTitle}`}
      </p>
      <div className="rooms-options-icons">
        {room.webCamera?.isExist && <Camera divClassName={iconClassName} />}
        {room.phone?.isExist && <Telephone divClassName={iconClassName} />}
        {room.laptop?.isExist && <Display divClassName={iconClassName} />}
        {room.projector?.isExist && <Projector divClassName={iconClassName} />}
        {room.touchScreenPanel?.isExist && (
          <TouchScreen divClassName={iconClassName} />
        )}
      </div>
      <p className={setClass("seat-number-text", isSelected && "active")}>{`${
        room.seatNumber
      } ${getTypeOfCountingPlural(room.seatNumber, seatsPlural)}`}</p>
    </div>
  );
};
